import { ReactNode, useContext, useEffect, useRef, useState } from 'react'
import { createPortal } from 'react-dom'

import { MapContext } from '@/feature/map/context/map'

import styles from './MapEmbedding.module.css'

export type MapEmbeddingProps = {
  children: ReactNode
  position: google.maps.ControlPosition
  defer?: boolean
  map?: google.maps.Map | null
  className?: string
}
export const MapEmbedding = ({
  children,
  position,
  defer = false,
  className,
  ...props
}: MapEmbeddingProps) => {
  const [embedding] = useState(() => {
    const el = document.createElement('div')

    el.className = styles.mapEmbedding

    return el
  })
  const mapControlPosition = useRef<number>(undefined)
  const [embedded, setEmbedded] = useState(false)

  // Map is required to specified or omitted leaving the hook order intact
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const map = 'map' in props ? props.map : useContext(MapContext)?.map

  useEffect(() => {
    if (className) {
      embedding?.classList.add(className)

      return () => {
        embedding?.classList.remove(className)
      }
    }
  }, [className])

  useEffect(() => {
    if (map?.controls?.[position]) {
      if (
        map.controls[position].getArray().includes(embedding) &&
        mapControlPosition.current !== undefined
      ) {
        map.controls[position].setAt(mapControlPosition.current, embedding)
      } else {
        mapControlPosition.current = map.controls[position].push(embedding) - 1
      }
      if (defer) {
        setEmbedded(true)
      }

      return () => {
        if (mapControlPosition.current !== undefined) {
          if (map.controls[position].getAt(mapControlPosition.current) === embedding)
            map.controls[position].removeAt(mapControlPosition.current)
        }
      }
    }
  }, [map, position, embedding, defer])
  return !defer || embedded ? createPortal(children, embedding) : null
}
